module.exports = __webpack_public_path__ + "static/media/earlexFlyer1Front.43f12193.jpg";